/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesProfileGetResponseConnectedGameFromJSON, FxIdWebFeaturesProfileGetResponseConnectedGameToJSON, } from './FxIdWebFeaturesProfileGetResponseConnectedGame';
import { FxIdWebFeaturesProfileGetResponseFeatureFromJSON, FxIdWebFeaturesProfileGetResponseFeatureToJSON, } from './FxIdWebFeaturesProfileGetResponseFeature';
import { FxIdWebFeaturesProfileGetResponseTwitchFromJSON, FxIdWebFeaturesProfileGetResponseTwitchToJSON, } from './FxIdWebFeaturesProfileGetResponseTwitch';
import { FxIdWebFeaturesProfileGetResponseSocialIdentifierFromJSON, FxIdWebFeaturesProfileGetResponseSocialIdentifierToJSON, } from './FxIdWebFeaturesProfileGetResponseSocialIdentifier';
/**
 * Check if a given object implements the FxIdWebFeaturesProfileGetResponse interface.
 */
export function instanceOfFxIdWebFeaturesProfileGetResponse(value) {
    if (!('AccountId' in value) || value['AccountId'] === undefined)
        return false;
    if (!('ConnectedGames' in value) || value['ConnectedGames'] === undefined)
        return false;
    if (!('MarketingEnabled' in value) || value['MarketingEnabled'] === undefined)
        return false;
    if (!('EmailValidated' in value) || value['EmailValidated'] === undefined)
        return false;
    if (!('Locale' in value) || value['Locale'] === undefined)
        return false;
    if (!('GeoCountry' in value) || value['GeoCountry'] === undefined)
        return false;
    if (!('Features' in value) || value['Features'] === undefined)
        return false;
    if (!('SocialIdentifiers' in value) || value['SocialIdentifiers'] === undefined)
        return false;
    if (!('HasEmail' in value) || value['HasEmail'] === undefined)
        return false;
    if (!('Guest' in value) || value['Guest'] === undefined)
        return false;
    if (!('HasCompletedOrder' in value) || value['HasCompletedOrder'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesProfileGetResponseFromJSON(json) {
    return FxIdWebFeaturesProfileGetResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AccountId': json['AccountId'],
        'ConnectedGames': (json['ConnectedGames'].map(FxIdWebFeaturesProfileGetResponseConnectedGameFromJSON)),
        'MarketingEnabled': json['MarketingEnabled'],
        'Email': json['Email'] == null ? undefined : json['Email'],
        'EmailValidated': json['EmailValidated'],
        'Locale': json['Locale'],
        'GeoCountry': json['GeoCountry'],
        'Name': json['Name'] == null ? undefined : json['Name'],
        'Features': (json['Features'].map(FxIdWebFeaturesProfileGetResponseFeatureFromJSON)),
        'SocialIdentifiers': (json['SocialIdentifiers'].map(FxIdWebFeaturesProfileGetResponseSocialIdentifierFromJSON)),
        'HasEmail': json['HasEmail'],
        'Guest': json['Guest'],
        'HasCompletedOrder': json['HasCompletedOrder'],
        'Twitch': json['Twitch'] == null ? undefined : FxIdWebFeaturesProfileGetResponseTwitchFromJSON(json['Twitch']),
    };
}
export function FxIdWebFeaturesProfileGetResponseToJSON(json) {
    return FxIdWebFeaturesProfileGetResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AccountId': value['AccountId'],
        'ConnectedGames': (value['ConnectedGames'].map(FxIdWebFeaturesProfileGetResponseConnectedGameToJSON)),
        'MarketingEnabled': value['MarketingEnabled'],
        'Email': value['Email'],
        'EmailValidated': value['EmailValidated'],
        'Locale': value['Locale'],
        'GeoCountry': value['GeoCountry'],
        'Name': value['Name'],
        'Features': (value['Features'].map(FxIdWebFeaturesProfileGetResponseFeatureToJSON)),
        'SocialIdentifiers': (value['SocialIdentifiers'].map(FxIdWebFeaturesProfileGetResponseSocialIdentifierToJSON)),
        'HasEmail': value['HasEmail'],
        'Guest': value['Guest'],
        'HasCompletedOrder': value['HasCompletedOrder'],
        'Twitch': FxIdWebFeaturesProfileGetResponseTwitchToJSON(value['Twitch']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileGetResponse.js.map